import { render } from "./Sparql.vue?vue&type=template&id=300b316c"
import script from "./Sparql.vue?vue&type=script&lang=js"
export * from "./Sparql.vue?vue&type=script&lang=js"

import "./Sparql.vue?vue&type=style&index=0&id=300b316c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__